// authEffects.js
import authInstance from "../Interceptor/interceptor";

export const setAuthorizationHeader = (token, email) => {
  if (token) {
    localStorage.setItem("accessToken", token);
    localStorage.setItem("email", email);
  } else {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("email");
  }
};

// Authentication effects
export const authenticateEffect = (formData) => {
  
  return authInstance.post("/auth/login", formData);
};

export const registerEffect = (data) => {
  return authInstance.post("/auth/register", data);
};

export const sendOtpEffect = (data) => {
  return authInstance.post("/auth/otpsend", data);
};

export const verifyOtpEffect = (data) => {
  return authInstance.post("/auth/verifyotp", data);
};

export const forgotPasswordEffect = (data) => {
  return authInstance.post("/auth/forgotpassword", data);
};

export const changePasswordEffect = (data) => {
  return authInstance.put("/auth/changepassword", data);
};

export const editAdminProfileEffect = (updatedData) => {
  return authInstance.put(`/profile/update`, updatedData);
};

export const viewAdminProfileEffect = (adminId) => {
  return authInstance.get(`/admin/getbooze?booze_id=${adminId}`);
};

export const logoutEffect = (data) => {
  return authInstance.post("/logout", data);
};

export const getAccessToken = (data) => {
  return authInstance.post('/auth/refreshtoken',data)
};
